import { lazy } from "react";
import Loadable from "components/Loadable.tsx";

const BindingTypeList = Loadable(lazy(() => import("features/bindingType/components/List")));
const BindingTypePage = Loadable(lazy(() => import("features/bindingType/components/Page")));


const routes = {
  path: "bindingType",
  children: [
    { path: "", element: <BindingTypeList /> },
    { path: "add", element: <BindingTypePage /> },
    { path: "edit/:bindingTypeID?", element: <BindingTypePage /> },
  ],
};

export default routes;
